<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/04-JS-find-out-whos-hiring.svg"
                class="img-fluid"
                alt="Find out who's hiring"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->
    <content-block class="p-4 bg-light-grey">
        <p>You may be surprised by how many departments commonly hire students. Here at Centennial, you could find work in…</p>
    </content-block>
    <!-- ACCORDION -->
    <content-block class="p-4">
      <!-- <h2 class="content-block__header">Accordion</h2> -->
      <div class="accordion">
        <accordion
          headerText="Athletics &amp; Recreation"
          accordionID="collapse01"
        >
          <p>Common jobs in <a href="https://www.gocolts.ca/landing/index" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Fitness attendant</li>
            <li>Front desk clerk</li>
          </ul>
        </accordion>
        <accordion
          headerText="Applied Research, Innovation and Entrepreneurship Services (ARIES)"
          accordionID="collapse02"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/ARIES" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Research assistant</li>
            <li>Student researcher</li>
            <li>Creative writer for <a href="https://wimtach.centennialcollege.ca/" target="_blank">Wearable, Interactive, Mobile Technologies and Access Centre in Health (WIMTACH)</a></li>
            <li>WIMTACH app developer</li>
          </ul>
        </accordion>
        <accordion
          headerText="Bookstore"
          accordionID="collapse12"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/student-life/campus-services/bookstore/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Team member</li>
            <li>Store manager</li>
          </ul>
        </accordion>
        <accordion
          headerText="Centennial College Student Association Inc. (CCSAI)"
          accordionID="collapse03"
        >
          <p>Common jobs in <a href="https://ccsai.ca/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Guest service representative</li>
            <li>Operations staff</li>
          </ul>
        </accordion>
        <accordion
          headerText="Centre for Academic Excellence and Program Quality"
          accordionID="collapse04"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/about-centennial/centres-and-institutes/teaching-excellence-and-academic-quality/centre-for-academic-quality/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Social media assistant</li>
            <li>Partner event assistant</li>
          </ul>
        </accordion>
        <accordion
          headerText="Centre for Accessible Learning and Counselling Services (CALCS)"
          accordionID="collapse05"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/student-life/student-services/centre-for-accessible-learning-and-counselling-services/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Technical aide</li>
            <li>Health and wellness ambassador</li>
            <li>Peer tutor</li>
          </ul>
        </accordion>
        <accordion
          headerText="Community Outreach"
          accordionID="collapse06"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/about-centennial/community-commitment/hype-helping-youth-pursue-education/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>HYPE mentor</li>
            <li>Administrative support</li>
          </ul>
        </accordion>
        <accordion
          headerText="Financial Aid"
          accordionID="collapse07"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/financial-aid/" target="_blank">this department</a> include…</p>
           <ul class="pt-1">
            <li>Financial services assistant</li>
          </ul>
        </accordion>
        <accordion
          headerText="Learning Centre"
          accordionID="collapse08"
        >
          <p>Common jobs in <a href="https://library.centennialcollege.ca/learning-centre/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Peer tutors in various subjects</li>
          </ul>
        </accordion>
        <accordion
          headerText="Library"
          accordionID="collapse9"
        >
          <p>Common jobs in <a href="https://library.centennialcollege.ca/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Peer academic coach</li>
            <li>Library shelver</li>
          </ul>
        </accordion>
        <accordion
          headerText="School of Advancement"
          accordionID="collapse10"
        >
          <p>Common jobs in <a href="https://www.centennialcollege.ca/about-centennial/schools/school-of-advancement/" target="_blank">this department</a> include…</p>
          <ul class="pt-1">
            <li>Research assistant</li>
            <li>Student researcher</li>
          </ul>
        </accordion>
      </div>
    </content-block>
    <content-block class="p-4 bg-light-grey">
        <p>When looking for an on-campus job, make sure to check each department’s website to get to know their mission, vision and services. Once you know what they do, the services they provide and the types of jobs they offer, you can decide which departments you’re interested in working in.</p>
        <p>Go to <a href="https://hire.centennialcollege.ca/home.htm" target="_blank">HireCentennial</a> to find openings on our job postings board. You can also book an appointment with an Employment Advisor to get your application ready.</p>
        <p>Find out about other opportunities by speaking to other students, faculty and staff.</p>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
